import { Box } from '@mui/material'
import AdxPopper from 'components/reusable/AdxPopper'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { updateJobAds } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'
import ViewJobAdsDialog from './ViewJobAdsDialog'

const DeactivatePopper = ({ id, goToManageApplicant }) => {
  //navigate
  const navigate = useNavigate()
  const goToManageEditJobAds = () => {
    navigate(`/app/recruitment/applicant-tracking/job-ads/${id}/edit`, {
      state: {
        id,
      },
    })
  }
  // modal
  const cancelModal = useOpenClose(false)
  const deactivateModal = useOpenClose(false)
  const viewJobAdsModal = useOpenClose(false)
  const successDeactivateSnackbar = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  // API CALL
  const queryClient = useQueryClient()

  const {
    isLoading: updateIsLoading,
    isSuccess: updateIsSuccess,
    error: updateError,
    isError: updateIsError,
    mutate: updateMutate,
  } = useMutation((id) => updateJobAds(id, 'deactivate'), {
    onSuccess: async () => {
      queryClient.resetQueries('getAllJobAds')
      queryClient.invalidateQueries('getAllJobAds')
      successDeactivateSnackbar.handleOpen()
    },
    onError: async (error) => {
      queryClient.invalidateQueries('getAllJobAds')
      errorSnackbar.handleOpen()
    },
  })

  const DeactivateJobAdsModal = () => (
    <AdxInfoModal
      modalWidth={600}
      muiIcon="error_icon"
      open={deactivateModal.isOpen}
      onClose={deactivateModal.handleClose}
      iconColor="error.main"
      title="Deactivate Job Advertisement?"
      subtitle="Are you sure you want to deactivate the job advertisement? This job advertisement will not be visible to the jobseeker and you will not receive new applications."
      variant={'error'}
      footerButtons
      firstBtnLabel={'Deactivate'}
      firstBtnHandle={() => {
        updateMutate(id)
        deactivateModal.handleClose = true
      }}
      isLoading={updateIsLoading}
      secondBtnLabel={'Cancel'}
      secondBtnHandle={deactivateModal.handleClose}
    />
  )

  return (
    <Box display="flex" alignItems="center" columnGap={2}>
      <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
        {/* <Box 
                onClick={()=>goToManageEditJobAds()}
              >
                Edit Details
              </Box> */}
        <Box
          // onClick={viewJobAdsModal.handleOpen}
          onClick={() => goToManageApplicant()}
        >
          View applicant(s)
        </Box>
        <Box
          onClick={deactivateModal.handleOpen}
          sx={{
            color: 'error.main',
          }}
        >
          Deactivate job
        </Box>
        {/* <Box 
              sx={{
                color:"error.main"
              }}
              onClick={cancelModal.handleOpen}
              >
                Delete job ads
              </Box> */}
      </AdxPopper>

      {deactivateModal.isOpen ? <DeactivateJobAdsModal /> : null}

      {successDeactivateSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job ad deactivated"
          open={successDeactivateSnackbar.isOpen}
          handleClose={successDeactivateSnackbar.handleClose}
        />
      ) : null}

      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}

      {viewJobAdsModal.isOpen ? (
        <ViewJobAdsDialog
          id={id}
          handleClose={viewJobAdsModal.handleClose}
          open={viewJobAdsModal.isOpen}
          data
        />
      ) : null}
    </Box>
  )
}
export default DeactivatePopper
